import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Logo from '../components/Logo';

const PolitiqueConfidentialite = () => {
  return (
    <div className="min-h-screen bg-slate-50/50">
      {/* Header */}
      <header className="bg-white border-b border-slate-100 px-4 sm:px-6 lg:px-8 py-4">
        <div className="max-w-4xl mx-auto flex items-center justify-between">
          <Link to="/" className="flex items-center">
            <Logo variant="full" size="h-10" />
          </Link>
          <Link to="/" className="flex items-center text-sm text-slate-600 hover:text-rose-600 transition-colors">
            <ArrowLeft className="w-4 h-4 mr-1" />
            Retour
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
        <div className="bg-white rounded-xl border border-slate-100 shadow-sm p-6 sm:p-8 lg:p-10">
          <h1 className="text-2xl sm:text-3xl font-bold text-slate-900 mb-2" style={{ fontFamily: 'Manrope, sans-serif' }}>
            Politique de confidentialité
          </h1>
          <p className="text-sm text-slate-500 mb-8">Dernière mise à jour : avril 2026</p>

          <div className="space-y-6 text-slate-700">
            <section>
              <h2 className="text-lg font-semibold text-slate-900 mb-2">Qui collecte vos données ?</h2>
              <p>
                La plateforme Plus (plus-conciergerie.com), éditée par Elise Dugand, collecte vos données personnelles 
                dans le cadre de l'achat d'options pour votre séjour.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-slate-900 mb-2">Quelles données sont collectées ?</h2>
              <p>
                Nom et prénom, adresse email, dates de séjour, options sélectionnées et données de transaction.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-slate-900 mb-2">Pourquoi ?</h2>
              <p>
                Uniquement pour traiter votre commande d'options, envoyer votre confirmation et permettre au 
                gestionnaire de votre logement de préparer votre séjour.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-slate-900 mb-2">Combien de temps ?</h2>
              <p>
                Vos données de transaction sont conservées 10 ans (obligation légale). Vos données personnelles 
                sont supprimées 12 mois après votre date de départ.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-slate-900 mb-2">Hébergement et transfert hors UE</h2>
              <p>
                Les données sont hébergées aux États-Unis par Emergent (
                <a href="https://emergent.sh" target="_blank" rel="noopener noreferrer" className="text-rose-600 hover:underline">
                  emergent.sh
                </a>
                ), certifié SOC 2 et ISO. Une mise en conformité RGPD est en cours de leur côté. 
                Ce transfert repose sur les exceptions prévues à l'article 49 du RGPD, notamment l'exécution 
                du contrat auquel vous êtes partie.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-slate-900 mb-2">Paiement</h2>
              <p>
                Les paiements sont traités par Stripe. Aucune donnée bancaire ne transite par nos serveurs.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-slate-900 mb-2">Vos droits</h2>
              <p>
                Conformément au RGPD, vous disposez d'un droit d'accès, de rectification, de suppression et de 
                portabilité de vos données. Pour exercer ces droits : {' '}
                <a href="mailto:elisedugand.pro@gmail.com" className="text-rose-600 hover:underline">
                  elisedugand.pro@gmail.com
                </a>
              </p>
            </section>

            <section className="pt-4 border-t border-slate-100">
              <h2 className="text-lg font-semibold text-slate-900 mb-2">Contact</h2>
              <p>
                <a href="mailto:elisedugand.pro@gmail.com" className="text-rose-600 hover:underline">
                  elisedugand.pro@gmail.com
                </a>
                {' '}— Elise Dugand, Palavas-les-Flots 34000 — SIREN 990 945 966 00010
              </p>
            </section>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-slate-100 bg-white py-6 mt-8">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row justify-center items-center gap-4 text-sm text-slate-500">
          <Link to="/politique-de-confidentialite" className="hover:text-rose-600 transition-colors">
            Politique de confidentialité
          </Link>
          <span className="hidden sm:inline">•</span>
          <Link to="/mentions-legales" className="hover:text-rose-600 transition-colors">
            Mentions légales
          </Link>
        </div>
      </footer>
    </div>
  );
};

export default PolitiqueConfidentialite;
